/*
 * @Author: taoyuan taoyuan@originqc.com
 * @Date: 2024-03-22 15:29:03
 * @LastEditors: zjy zjy@originqc.com
 * @LastEditTime: 2024-04-23 15:44:11
 * @FilePath: \qcloud-web-pc-4.0\src\hooks\user_update_userinfo.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import { encryUserInfo } from '@/api/index';

import { useAppDispatch } from '@/redux/hooks';
import { decMsg, getPk } from '@/utils/kyberSm2';
import { setCompleted, setLoginStatus, setUserInfo, initialState } from '@/features/user/userSlice';
// import { zhugeTrack } from '@/utils/utils';

type CallbackFn = (...args: any) => any;

/**
 * @description: 更新用户信息
 * @param {function} dispatch 更新信息到状态库方法
 * @param {function} successFn 成功回调
 * @param {function} errFn 失败回调
 * @return {*}
 */
export const useUpdateUserInfo = (  ): CallbackFn => {
  const dispatch = useAppDispatch();
  const getUserMessage = async(successFn?: CallbackFn, errFn?: CallbackFn) => {
    const { cipher1, cipher2, salt } = await getPk(true)
    return encryUserInfo({cipher1, cipher2, salt}).then(async data => {
      if (data.success) {
        const useinfo = await decMsg(data.obj.user,salt);
        const userInfo = JSON.parse(useinfo ?? '');
        // console.log('userInfo', userInfo)
        dispatch(setCompleted(true))
        dispatch(setLoginStatus(true))
        dispatch(setUserInfo(userInfo))
        successFn && successFn(userInfo);
        window.zhuge.identify(userInfo.id, {
          name: userInfo.name, 
          tel: userInfo.tel,
        //预定义属性
        });
      } else {
        dispatch(setCompleted(true))
        dispatch(setLoginStatus(false))
        dispatch(setUserInfo({...initialState}))
        errFn && errFn();
      }
    }).catch((err) => {
      dispatch(setCompleted(true))
      dispatch(setLoginStatus(false))
      dispatch(setUserInfo({...initialState}))
      errFn && errFn();
    });
  };
  return getUserMessage;
};

export default useUpdateUserInfo;













